import React from 'react';
const ReactGA = React.lazy(()=>import('./ReactGAIntegration_Internal'));
function ReactGaIntegration(props){
    return <React.Suspense>
        <ReactGA {...props} />
    </React.Suspense>
}

export default ReactGaIntegration;
